import { styled, Theme } from '@mui/material';

export const drawerWidth = 270;

export const buttonStyles = (open: boolean | undefined) => ({
  display: 'flex',
  justifyContent: open ? 'flex-start' : 'center',
  minWidth: 0,
  width: `calc(${drawerWidth}px - 1.875rem)`,
  padding: '0.5rem',
  color: '#49454F',
  textTransform: 'none',
  transition: (theme: Theme) =>
    theme.transitions.create(['width', 'padding'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  '& .MuiButton-startIcon': {
    margin: 0,
    marginRight: open ? (theme: Theme) => theme.spacing(1.5) : 0,
  },
});

export const DrawerHeader = styled('div')(({ theme }: { theme: Theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));
